export const toPersianExisting = {
  gram: 'گرم',
  kilogram: 'کیلوگرم',
  liter: 'لیتر',
  ton: 'تن',
};
